import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { InformationBoxComponent } from '@principle-theorem/ng-principle-shared';
import {
  ACC_BOOLEAN_DISPLAY_MAP,
  ACC_PROVIDER_TYPE_MAP,
  ACC_REHABILITATION_DISPLAY_MAP,
  ACC_REHABILITATION_MAP,
  AccBooleanValue,
} from '@principle-theorem/principle-core/interfaces';
import { AccAssistanceFormGroup } from '../../form-groups/acc-injury.formgroup';
import { AccReferralManagementFormGroup } from '../../form-groups/acc-referrals.formgroup';
import { toOptions } from '@principle-theorem/shared';

@Component({
  selector: 'pr-acc-assistance-step',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    InformationBoxComponent,
  ],
  templateUrl: './acc-assistance-step.component.html',
  styleUrl: './acc-assistance-step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccAssistanceStepComponent {
  referralForm = input.required<AccReferralManagementFormGroup>();
  assistanceForm = input.required<AccAssistanceFormGroup>();
  disabled = input<boolean>(false);

  readonly booleanOptions = toOptions(AccBooleanValue);
  readonly booleanDisplay = ACC_BOOLEAN_DISPLAY_MAP;
  readonly rehabilitationDisplay = ACC_REHABILITATION_DISPLAY_MAP;
  readonly rehabilitationOptions = toOptions(ACC_REHABILITATION_MAP).reverse();
  readonly providerTypeOptions = toOptions(ACC_PROVIDER_TYPE_MAP);
}
